export default __webpack_public_path__ + "static/media/m-desc-btn.13ad24c8.svg";